module.exports = __webpack_public_path__ + "static/media/Accounting-Technicians-Ireland.a818aca7.png";